/**
 * Created by jiachenpan on 16/11/18.
 */
import XLSX from 'xlsx';
import { MessageBox } from 'element-ui';
import { isObject, isNumber, isUndefined, isString } from '@/utils/validate';

export function parseTime(time, cFormat) {
    if (getOS().isSafari) {
        time = time.replace(/-/g,'/');
    }
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

export function formatTime(time, option) {
    time = +time * 1000
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) { // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
}


export function readExcel(file, callback) {
    var fileReader = new FileReader();
    var persons = []; // 存储获取到的数据
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(file);
    fileReader.onload = function(ev) {
        try {
            var data = ev.target.result,
                workbook = XLSX.read(data, {
                    type: 'binary'
                }); // 以二进制流方式读取得到整份excel表格对象
        } catch (e) {
            console.log('文件类型不正确');
            return;
        }

        // 表格的表格范围，可用于判断表头是否数量是否正确
        var fromTo = '';
        // 遍历每张表读取
        for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
                fromTo = workbook.Sheets[sheet]['!ref'];
                persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                // break; // 如果只取第一张表，就取消注释这行
            }
        }
        callback(persons);
    };
}

export function openImageBox(url) {
    MessageBox.alert(`<img src=${url} style="width: 300px;"></img>`, '', {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        closeOnClickModal: true,
        center: true
    }).catch(() => {})
}

export function searchSubStr(str, subStr) {
    let pos = str.indexOf(subStr),
        positions = [];
    while (pos > -1) {
        positions.push(pos);
        pos = str.indexOf(subStr, pos + 1);
    };
    return positions;
}

export function removeStr(content, string) {
    // 获取传入content中符合string的所有位置
    let positions = searchSubStr(content, string),
        str = [];
    // content中存在string的情况
    if (positions.length > 0) {
        // 先保存起始位置至第一个string出现位置的字符串
        str.push(content.substring(0, positions[0]));
        // 使用for循环确保当content中存在多个string时也可正确处理
        for (let i = 0; i < positions.length; i++) {
            let subStr = '';
            // 是否为最后一个position
            if (positions[i + 1]) {
                subStr = content.substring(positions[i], positions[i + 1]);
            } else {
                subStr = content.substring(positions[i]);
            }
            // substr中string前后字符串
            let front = subStr.slice(0, subStr.indexOf('(')),
                after = subStr.slice(subStr.indexOf(')') + 1);
            str.push(front);
            str.push(after);
        };
        return str.join('');
    } else { // content中不存在string的情况
        return content;
    }
}

export function getOS() {
    var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian,
        isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
        isSafari: isSafari
    };
}

// 转换文件大小（按单位）,例如 字节数(bytes) / 1024 返回为 KB
export function transformFileSize(size = 0, units = 1024, emptyValue = '0') {
    const number = size > 0 ? (size / units) : 0;
    return (number > 0 ? number.toFixed(2) : '') || emptyValue
}

/**
 * 获取某个对象属性的值，支持多级查找
 * @param {Object} obj 被查找的对象
 * @param {number|string|array} _keys 要查找的属性名称，列如：1, 'a.b', 'b.0.a', ['a', 'b']
 * @param {any} defaultValue 找不属性时的默认值
 * @return {any}
 * */
export function getValue(obj, _keys, defaultValue) {
    if (!isObject(obj)) {
        return defaultValue;
    }

    let keys;
    if (isNumber(_keys)) {
        _keys = String(_keys);
    }
    if (isString(_keys)) {
        keys = _keys.split('.')
    } else {
        keys = Array.isArray(_keys) ? _keys : []
    }

    const result = (keys).reduce((parentProp, key) => {
        // 如果是 Object or Array 可以尝试获取属性的值
        return isObject(parentProp) || Array.isArray(parentProp) ? parentProp[key] : undefined
    }, obj);

    return isUndefined(result) ? defaultValue : result;
}

// 解析URL中的参数为Object对象
export function parseUrlSearch(search) {
    const paramsList = search.replace(/^[^?]*\?/, '').split('&');
    const params = {};

    paramsList.forEach((item) => {
        const arr = item.split('=');
        params[arr[0]] = arr[1] || ''
    });

    return params;
}



// WEBPACK FOOTER //
// ./src/utils/index.js